import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "title"
};
const _hoisted_2 = {
  class: "desc"
};
const _hoisted_3 = {
  key: 0,
  class: "desc"
}; // import {CloseBold} from '@element-plus/icons-vue'

import { ElRow } from "element-plus";
export default {
  __name: 'PreparedPropCard',
  props: {
    data: {
      type: Object,
      required: true
    },
    status: {
      type: Number,
      default: -1,
      required: false
    }
  },

  setup(__props) {
    return (_ctx, _cache) => {
      return __props.data ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["prop-container", `status_${__props.status}`])
      }, [_createVNode(_unref(ElRow), {
        style: {
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("text", _hoisted_1, _toDisplayString(__props.data.name) + _toDisplayString(__props.data.times === 0 ? '' : ` * ${__props.data.times}`), 1)]),
        _: 1
      }), _createElementVNode("text", _hoisted_2, " 性能：" + _toDisplayString(__props.data.function_desc), 1), __props.data.deep_desc ? (_openBlock(), _createElementBlock("text", _hoisted_3, " 深层：" + _toDisplayString(__props.data.deep_desc), 1)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true);
    };
  }

};